var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(_vm.layout,{tag:"component",attrs:{"loggedIn":_vm.loggedIn}},[_vm._t("default"),_c('transition',{attrs:{"name":"fade","mode":"out-in","duration":"400"}},[_c('router-view')],1)],2)}
var staticRenderFns = []

export { render, staticRenderFns }